import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Auth from '../../../../Auth';
import { getUser } from 'Actions/users';
import withConfig from 'HOCs/withConfig/withConfig';
import withMessage from 'HOCs/withMessage/withMessage';
import { injectIntl } from 'react-intl';
import withRouter from 'HOCs/withRouter';
import { userSelector } from 'Selectors/users';
import withTrack from 'HOCs/withTrack/withTrack';
import { shouldShowTips } from 'Helpers/safetyTips';
import { urls as urlsItems } from 'Reducers/items';
import { get } from 'Server';
import { itemSelector } from 'Selectors/items';
import setLoginModalState from 'Actions/setLoginModalState';

export class CallsContainer extends React.Component {
    static propTypes = {
        onTrack: PropTypes.func,
        item: PropTypes.object,
        trackFilters: PropTypes.object,
        trackFiltersMetadata: PropTypes.object,
        trackOrigin: PropTypes.string,
        toggleFirstTimeUserTips: PropTypes.func,
        config: PropTypes.object,
        tipsInitiationPoint: PropTypes.string,
        userData: PropTypes.object,
        sendChatMessage: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
        children: PropTypes.func.isRequired,
        getUser: PropTypes.func.isRequired,
        shouldTrackTap: PropTypes.bool,
        getItemPhone: PropTypes.func.isRequired,
        phone: PropTypes.string,
        setLoginModalState: PropTypes.func.isRequired,
        trackerOrigins: PropTypes.object,
        trackingProps: PropTypes.object,
        location: PropTypes.object
    };

    static defaultProps = {
        onTrack: () => { },
        user: {},
        item: {},
        trackFilters: {},
        setLoginModalState: () => {},
        trackFiltersMetadata: {},
        trackOrigin: '',
        tipsInitiationPoint: '',
        userData: {},
        shouldTrackTap: false,
        trackerOrigins: {},
        trackingProps: {},
        showCall: true
    };

    componentDidUpdate(prevProps) {
        if (prevProps.tipsInitiationPoint !== this.props.tipsInitiationPoint
            && this.props.tipsInitiationPoint === 'call') {
            if (this.setCurrentClicked) {
                this.callAction(this.props.phone, this.props.shouldTrackTap);
            }
        }

        if (this.props.phone !== prevProps.phone && this.state.callTriggered) {
            this.callAction(this.props.phone);
        }
    }

    state = {
        isFetchingPhone: false,
        callTriggered: false
    };

    getPhone = (shouldTrack = false, params) => {
        if (Auth.isLoggedIn()) {
            if (shouldTrack) {
                this.track('item_tap_phone');
            }

            this.setState(state => ({ isFetchingPhone: !state.isFetchingPhone }));

            let promise;

            if (this.props.item.has_phone_param) {
                promise = this.props.getItemPhone(this.props.item.id);
            }
            else {
                promise = this.props.getUser(this.props.userData.id, params);
            }

            return promise.then(() => {
                this.setState(prevState => ({
                    isFetchingPhone: !prevState.isFetchingPhone
                }), () => {
                    this.callTriggered();
                });
            });
        }

        if (shouldTrack) {
            this.track('item_intent_call');
        }

        const { MAKE_CALL } = this.props.trackerOrigins;

        return new Promise(resolve => {
            this.props.setLoginModalState({
                state: true,
                redirectTo: '',
                ...MAKE_CALL && { origin: MAKE_CALL },
                entryPoint: 0,
                callback: () => {
                    this.getPhone().then(() => {
                        resolve();
                    });
                }
            });
        });
    }

    track = eventName => {
        this.props.onTrack(eventName, this.props.trackingProps);
    };

    callTriggered = () => {
        const user = Auth.getUser();

        this.props.sendChatMessage(
            this.props.intl.formatMessage(
                { id: 'callDefaultMsg' },
                { name: user && user.name }
            ),
            this.props.item.user_id,
            this.props.item.id,
            'call'
        );
    };

    trackCallToAction = (event, extraTrackAttr = {}) => this.props.onTrack(event, {
        origin: this.props.trackOrigin,
        filters: this.props.trackFilters,
        select_from: 'item_page',
        ...this.props.trackFiltersMetadata,
        ...extraTrackAttr,
        seller_id: this.props.item.id
    });

    callAction = (shouldTrack = true) => {
        const { location } = this.props;

        if (!this.props.toggleFirstTimeUserTips || !this.props.config.get('firstTimeSafetyTip') || !shouldShowTips()) {
            if (shouldTrack) {
                const extraTrackAttr = {
                    chosen_option: 'call_now'
                };

                if (location && location.state && location.state.feed_version) {
                    extraTrackAttr.feed_version = location.state.feed_version;
                }

                this.trackCallToAction('item_tap_call', extraTrackAttr);
            }
            document.location.href = `tel://${this.props.phone}`;
        }
        else {
            this.props.toggleFirstTimeUserTips('call');
            this.setCurrentClicked = 'phone_number_control';
        }
    };

    handleClickCall = (callbacked, shouldTrack = true) => () => {
        if (!callbacked) {
            this.trackCallToAction('item_call_button_press');
        }

        this.setState(state => ({
            callTriggered: !state.callTriggered
        }));

        return this.callAction(shouldTrack);
    };

    render() {
        return this.props.children({
            clickHandler: this.handleClickCall,
            isFetchingPhone: this.state.isFetchingPhone,
            requestPhone: this.getPhone,
            callTriggered: this.callTriggered,
            phone: this.props.phone
        });
    }
}

const getPhoneNumber = (item, user) => {
    return item.has_phone_param
        ? item.ad_phone
        : user.phone;
};

const mapStateToProps = (state, props) => {
    const item = props.isMyZone
        ? state.myZone.adsData[props.itemId]
        : itemSelector(state, props);
    const userData = userSelector(state, item.user_id);
    const phone = getPhoneNumber(item, userData);

    return {
        trackFilters: state.track.filters,
        trackFiltersMetadata: state.track.filtersMetadata,
        trackOrigin: state.track.origin,
        userData,
        item,
        phone
    };
};

const mapDispatchToProps = dispatch => ({
    getUser: (userId, params) => dispatch(getUser(userId, true, params)),
    getItemPhone: itemId => dispatch(get(urlsItems.getItemPhone(itemId), 'ELEMENT_ITEMS')),
    setLoginModalState: state => dispatch(setLoginModalState(state))
});

export default compose(
    withRouter,
    withTrack,
    withConfig,
    withMessage,
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps)
)(CallsContainer);
